export default __webpack_public_path__ + "static/media/deadlinetrack.a682502a.png";